(function() {

    function cookies() {
        let agree = localStorage.getItem('cookie_agree');
        let container = document.querySelector('.cookieInfo');
        if( agree ) {
            if(container) {
                container.style.display = 'none';
            }
        } else {
            container.style.display = 'block';
            let btn = document.querySelector('#close-cookies');

            if(btn) {
                btn.addEventListener('click', function(e) {
                    e.preventDefault();
                    localStorage.setItem('cookie_agree', true);

                    if(container) {
                        container.style.display = 'none';
                    }
                });
            }
        }

    }

window.addEventListener('load', function() {
    cookies();
});

})();


//////////////////
// WEBPACK FOOTER
// ./js/cookies.js
// module id = 5
// module chunks = 0